import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from "../../services/user.service";
import {RuoloUtenteEnum} from 'src/model/enum/TipologiaUtenteEnum';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'

})
export class SidebarComponent implements OnInit {
  sidebarItems: any[] = [];
  isCollapsed = false;

  constructor(private router: Router, private userService: UserService) {
  }

  async ngOnInit() {
    const user = await this.userService.getUser();
    if (user) {
      this.sidebarItems = [];

      if (user?.ruoli.includes('check_iban_user')) {
        this.sidebarItems.push(     
          {
            "href": "/check-iban",
            "text": "IBAN Check",
            "icon": "checkmark",
            "id": "sidebar_cruscotto"
          });

 
      }

      if (window.location.href.includes('claims-platform-qual')) 
        {  console.log('qual');  
          this.sidebarItems.push({    
            "href": "https://claims-platform-qual.generali.it/s1/ams/",    
            "text": "AMS",    
            "icon": "globe",    
            "id": "AMS"  });
          }
          
      if (this.userService.determineSicAniaUser()) {
        this.sidebarItems.push({
          href: '/sic-ania',
          text: 'SIC Ania',
          icon: 'clipboard',
          id: 'sidebar_sic_ania',
        });
      }
      if (user?.ruoli.includes('sms_sender')) {
        this.sidebarItems.push(
          {
            "href": "/sms-sender",
            "text": "SMS Sender",
            "icon": "chatbubble-ellipses-outline",
            "id": "sidebar_sms_sender"
          });
      }
      if (user?.ruoli.includes(RuoloUtenteEnum.UTENTE_SMART_SUM.toString())) {
        this.sidebarItems.push(
          {
            "href": "/smart-summary",
            "text": "Smart Summary",
            "icon": "file-tray-full",
            "id": "sidebar_smart-summary"
          }
        )
      }
      if (user?.ruoli.includes('admin') && !user?.ruoli.includes(RuoloUtenteEnum.ANIA_ADMIN.toString())) {
        this.sidebarItems.push(
          {
            "href": "/quicksight",
            "text": "Statistiche",
            "icon": "bar-chart",
            "id": "sidebar_statistiche",
            "childrenItems": [
              {text: "IbanCheck", href: "/quicksight", "id": "statistiche_ibancheck"},
              // {text: "Statistiche SMSSender", href: "/quicksight", "id": "statistiche_smssender"},
            ]
          });
      }
      if (user.ruoli.includes(RuoloUtenteEnum.ANIA_ADMIN.toString()) && !user.ruoli.includes('admin')) {
        this.sidebarItems.push(
          {
            "href": "/quicksight",
            "text": "Statistiche",
            "icon": "bar-chart",
            "id": "sidebar_statistiche",
            "childrenItems": [
              {text: "Statistiche SicAnia", href: "/quicksight-sic-ania", "id": "statistiche_ania"},
              // {text: "Statistiche SMSSender", href: "/quicksight", "id": "statistiche_smssender"},
            ]
          });
      }

      if (user.ruoli.includes(RuoloUtenteEnum.ANIA_ADMIN.toString()) && user.ruoli.includes('admin')) {
        this.sidebarItems.push(
          {
            "href": "/quicksight",
            "text": "Statistiche",
            "icon": "bar-chart",
            "id": "sidebar_statistiche",
            "childrenItems": [
              {text: "Statistiche IbanCheck", href: "/quicksight", "id": "statistiche_ibancheck"},
              {text: "Statistiche SicAnia", href: "/quicksight-sic-ania", "id": "statistiche_ania"}
            ]
          });
      }
      console.log(user.ruoli);
      if (user.ruoli.includes(RuoloUtenteEnum.SMS_SENDER_ADMIN.toString())) {
        console.log(user.ruoli);
        if (this.sidebarItems.filter(item => item.text === 'Statistiche').length > 0) {
          this.sidebarItems.filter(item => item.text === 'Statistiche')[0].childrenItems.push({
            text: "Statistiche SMSSender",
            href: "/quicksight-sms-sender",
            "id": "statistiche_smssender"
          });
        } else {
          this.sidebarItems.push(
            {
              "href": "/quicksight",
              "text": "Statistiche",
              "icon": "bar-chart",
              "id": "sidebar_statistiche",
              "childrenItems": [
                {text: "Statistiche SMSSender", href: "/quicksight-sms-sender", "id": "statistiche_smssender"}
              ]
            });
        }
      }
      if (user.ruoli.includes(RuoloUtenteEnum.SMART_SUMMARY_ADMIN.toString())) {
        console.log(user.ruoli);
        if (this.sidebarItems.filter(item => item.text === 'Statistiche').length > 0) {
          this.sidebarItems.filter(item => item.text === 'Statistiche')[0].childrenItems.push({
            text: "Statistiche SmartSummary",
            href: "/quicksight-smart-summary",
            "id": "statistiche_smartsumm",
          });
        } else {
          this.sidebarItems.push(
            {
              "href": "/quicksight",
              "text": "Statistiche",
              "icon": "bar-chart",
              "id": "sidebar_statistiche",
              "childrenItems": [
                {text: "Statistiche SmartSummary", href: "/quicksight-smart-summary", "id": "statistiche_smartsumm"}
              ]
            });
        }
      }
    }
  }

  navigateTo($event: any) {
    if ($event.detail.href.startsWith('http')) {
      window.location.href = $event.detail.href
      return;
    }
    this.router.navigate([$event.detail.href]);
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

}
